import { setSubaccountHeader } from 'src/helpers/subaccounts';
import sparkpostApiRequest from './helpers/sparkpostApiRequest';

export function listDkimKeys({ domain, subaccount }) {
  return sparkpostApiRequest({
    type: 'LIST_DKIM_KEYS',
    meta: {
      method: 'GET',
      url: `/v1/sending-domains/${domain}/dkim-keys`,
      headers: setSubaccountHeader(subaccount),
      domain
    }
  });
}

export function getDkimKey({ domain, keyId, subaccount }) {
  return sparkpostApiRequest({
    type: 'GET_DKIM_KEY',
    meta: {
      method: 'GET',
      url: `/v1/sending-domains/${domain}/dkim-keys/${keyId}`,
      headers: setSubaccountHeader(subaccount),
      domain,
      keyId
    }
  });
}

export function createDkimKey({ domain, subaccount, ...data }) {
  return sparkpostApiRequest({
    type: 'CREATE_DKIM_KEY',
    meta: {
      method: 'POST',
      url: `/v1/sending-domains/${domain}/dkim-keys`,
      headers: setSubaccountHeader(subaccount),
      data,
      domain
    }
  });
}

export function updateDkimKey({ domain, keyId, subaccount, ...data }) {
  return sparkpostApiRequest({
    type: 'UPDATE_DKIM_KEY',
    meta: {
      method: 'PUT',
      url: `/v1/sending-domains/${domain}/dkim-keys/${keyId}`,
      headers: setSubaccountHeader(subaccount),
      data,
      domain,
      keyId
    }
  });
}

export function deleteDkimKey({ domain, keyId, subaccount }) {
  return sparkpostApiRequest({
    type: 'DELETE_DKIM_KEY',
    meta: {
      method: 'DELETE',
      url: `/v1/sending-domains/${domain}/dkim-keys/${keyId}`,
      headers: setSubaccountHeader(subaccount),
      domain,
      keyId
    }
  });
}

export function verifyDkimKey({ domain, keyId, subaccount }) {
  return sparkpostApiRequest({
    type: 'VERIFY_DKIM_KEY',
    meta: {
      method: 'POST',
      url: `/v1/sending-domains/${domain}/dkim-keys/${keyId}/verify`,
      headers: setSubaccountHeader(subaccount),
      domain,
      keyId
    }
  });
}

export function clearDkimKeys() {
  return { type: 'CLEAR_DKIM_KEYS' };
}
